import * as React from "react";
import {Field, reduxForm, InjectedFormProps} from 'redux-form'
import {AppState} from "../../../store/app_state";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";
import * as Validator from "../../../../util/validation";

import FormInput from "../../../common/atom/form/form_input";
import styled from "styled-components";
import {ConstBorderRound, ConstColor} from "../../../../config/styles_const/styles_const";
import BtnCorporateLarge from "../../../common/atom/btn/btn_corporate_large";
import ErrorText from "../../../common/atom/text/error_text";

const validate = (values: any) => {
    const errors: any = {};
    return errors;
}

const renderInputCustom = (field: any) => {
    const hasError = !!field.meta.error && !!field.meta.touched;

    return (
        <React.Fragment>
            <CustomInput
                {...field.input}
                type={field.type}
                placeholder={field.placeholder}
            />
            {hasError &&
            <div>
                <ErrorText>{field.meta.error}</ErrorText>
            </div>}
        </React.Fragment>
    );
}

interface IStateProps {
}

interface IProps extends IStateProps {
}

interface IState {
}

export class CustomerProjectsSearchForm extends React.Component<IProps & InjectedFormProps<{}, IProps>, IState> {

    constructor(props: IProps & InjectedFormProps<{}, IProps>) {
        super(props);

        this.state = {};
    }


    public render(): JSX.Element {

        const { handleSubmit} = this.props;

        return (
            <React.Fragment>

                <FormWrapper>
                    <form
                        name="CustomerProjectsHeaderForm"
                        onSubmit={handleSubmit}>
                        <SearchInputWrapper>
                            <Field
                                placeholder="フリーワード検索"
                                name="q"
                                component={renderInputCustom}
                                type="text"
                                validate={[Validator.query]}
                            />
                            <IconButton
                                name="CustomerProjectHeaderForm-submit"
                                aria-label="Search"
                                type="submit"
                                icon={"'\f002'"}
                            />
                        </SearchInputWrapper>
                    </form>
                </FormWrapper>
            </React.Fragment>
        )
    };

}

const mapStateToProps = (state: AppState) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};

export default reduxForm({
    form: "CustomerProjectsSearchForm",
    validate,
})(connect(mapStateToProps, mapDispatchToProps)(CustomerProjectsSearchForm));

const FormWrapper = styled.div`
    margin-bottom: 20px;
`;

const CustomInput = styled(FormInput)`
    height: 50px;
    border: 1px solid ${ConstColor.Base};
    border-radius: ${ConstBorderRound.CornerRoundLeftTopLeftBottom};
`;

const SearchInputWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const IconButton = styled(BtnCorporateLarge)`
    width: 70px;
    border-top: 1px solid ${ConstColor.Base};
    border-right: 1px solid ${ConstColor.Base};
    border-bottom: 1px solid ${ConstColor.Base};
    border-radius: ${ConstBorderRound.CornerRoundRightTopRightBottom};
`;


// WEBPACK FOOTER //
// ./src/presentation/component/customer/projects/customer_projects_search_form.tsx